import { IAtBy } from "interfaces/at-by";
import { IEchoFunction, EchoFunctionType } from "interfaces/echo-function";
import { GraphQLData } from "interfaces/graphql-data";
import { IMessageType } from "interfaces/message-type";
import { ITenant } from "interfaces/tenant";
import { MessageTypeModel } from "models/message-type/messagetype-model";
import { AtByModel } from "../at-by-model";
import { TenantModel } from "../tenant/tenant-model";

export class FunctionModel implements IEchoFunction, GraphQLData {

  /*
  argumentMessageType: IMessageType,
  code: string,
	created: IAtBy,
  description: string,
  name: string,
	readme: string,
  lastModified: IAtBy,
	requirements: Array<string>,
	system: boolean,
	tenant: ITenant,
	typeName: string,
	returnMessageType?: IMessageType,
	type: IFunctionType*/
  argumentMessageType: IMessageType = new MessageTypeModel();
  code: string = '';
  created: IAtBy = new AtByModel('', '');
  description: string = '';
  name: string = '';
  readme: string = '';
  lastModified: IAtBy = new AtByModel('', '');
  requirements: string[] = [];
  system: boolean = false;
  tenant: ITenant = new TenantModel();
  typeName: string = '';
  type: EchoFunctionType = EchoFunctionType.processor;
  lastEvaluatedKey: string = '';
  returnMessageType: IMessageType = new MessageTypeModel();

  public static create(
    argumentMessageType: IMessageType,
    code: string,
    created: IAtBy,
    description: string,
    name: string,
    readme: string,
    lastModified: IAtBy,
    requirements: string[],
    system: boolean,
    tenant: ITenant,
    typeName: string,
    type: EchoFunctionType,
    returnMessageType: IMessageType) : FunctionModel {
    const t = new FunctionModel();
    t.argumentMessageType = argumentMessageType;
    t.code = code;
    t.created = created;
    t.description = description;
    t.name = name;
    t.readme = readme;
    t.lastModified = lastModified;
    t.requirements = requirements;
    t.system = system;
    t.tenant = tenant;
    t.typeName = typeName;
    t.type = type;
    t.returnMessageType = returnMessageType;
    return t;
  }

  async hydrate(data: any, tenant: ITenant): Promise<void> {
    console.log(data);
  }
}